import React, { Component } from "react";
import { css } from "@emotion/core";
import FadeLoader from "react-spinners/FadeLoader";

// Can be a string as well. Need to ensure each key-value pair ends with ;
const override = css`
  display: block;
  margin: 100px auto;
  border-color: #228ecd;
`;

class Loader extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
    };
  }

  render() {
    return (
      <div className="sweet-loading">
        <FadeLoader
          css={override}
          size={150}
          color={"#228ecd"}
          loading={this.state.loading}
          height={15}
          width={5}
          radius={2}
        />
      </div>
    );
  }
}
export default Loader;



// WEBPACK FOOTER //
// ./src/pages/ElevationForm/Loader.js